export default {
  index: [
    {
      path: '/zkyjpt',
      component: resolve => require(['./zkcommissionptIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpromoter_commission_configpt/_router.js